import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SdgHeaderComponent } from '../sdg-header/sdg-header.component';
import * as $ from 'jquery';

@Component({
  providers:[SdgHeaderComponent],
  selector: 'app-sdg-home',
  templateUrl: './sdg-home.component.html',
  styleUrls: ['./sdg-home.component.css']
})
export class SdgHomeComponent implements OnInit {

  constructor(private router: Router, private sdgHeader: SdgHeaderComponent) { }

  ngOnInit() {
  }
    frontBtnClick(){
        this.router.navigateByUrl('/')
    }
    homeBtnClick(){
        this.router.navigateByUrl('/sdg/sdg-home')
    }
    capacityBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".capacity-click").addClass("header_active")        
        this.router.navigateByUrl('/sdg/capacity-quest')
    }
    statusBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".status-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/status-quest')

        //this.sdgHeader.statusBtnClick()
    }
    financeBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".finance-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/finance-quest')
    }
    integrityBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".integrity-click").addClass("header_active")        
        this.router.navigateByUrl('/sdg/transparency-quest')
    }
    genderBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".gender-click").addClass("header_active")        
        this.router.navigateByUrl('/sdg/gender-quest')
    }
    policyBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".policy-click").addClass("header_active")
        this.router.navigateByUrl('/sdg/policy-quest')
    }
    resilienceBtnClick(){
        $(".header_active").removeClass("header_active")
        $(".resilience-click").addClass("header_active")        
        this.router.navigateByUrl('/sdg/resilience-quest')
    }
    viewSummaryBtnClick(){
        this.router.navigateByUrl('/view-summary')
    }
}



// WEBPACK FOOTER //
// ./src/app/sdg/sdg-home/sdg-home.component.ts